import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/motion";
import ProductCard from "@/components/ProductCard";
import { useSite } from "@/context/SiteContext";

export default function FeaturedProducts() {
  const { products } = useSite();

  return (
    <section data-testid="featured-products-section" className="py-20 sm:py-28">
      <div className="container-site">
        <div className="max-w-2xl">
          <Reveal>
            <Eyebrow>Our Portfolio</Eyebrow>
            <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-[2.75rem] font-extrabold tracking-tight text-brand-deep leading-[1.1]">
              Seeds Selected for Better Farming Potential
            </h2>
            <p className="mt-4 text-base sm:text-lg text-brand-charcoal/65 leading-relaxed">
              Explore the ICROPSIA product range, developed and presented with a focus on quality, consistency, and the
              practical needs of farmers and agricultural partners.
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-7 lg:gap-9">
          {products.map((p, i) => (
            <ProductCard key={p.slug} product={p} index={i} />
          ))}
        </div>

        <Reveal className="mt-20">
          <div className="rounded-3xl border border-brand-deep/10 bg-white shadow-xl shadow-brand-deep/5 overflow-hidden">
            <div className="flex items-center justify-between px-7 py-5 border-b border-brand-deep/10 bg-brand-beige/50">
              <h3 className="font-display font-bold text-brand-deep text-lg">Quick Product Comparison</h3>
              <Link to="/products" data-testid="comparison-view-all" className="hidden sm:inline-flex items-center gap-1.5 text-sm font-bold text-brand-deep hover:text-brand-gold transition-colors">
                Full Catalog <ArrowUpRight className="w-4 h-4" />
              </Link>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full text-sm min-w-[560px]">
                <thead>
                  <tr className="text-left text-xs uppercase tracking-wider text-brand-deep/50 border-b border-brand-deep/10">
                    <th className="px-7 py-4 font-semibold">Product</th>
                    <th className="px-4 py-4 font-semibold">Crop</th>
                    <th className="px-4 py-4 font-semibold">Pack Size</th>
                    <th className="px-4 py-4 font-semibold">Suitable Region</th>
                    <th className="px-7 py-4 font-semibold text-right">Technical Details</th>
                  </tr>
                </thead>
                <tbody>
                  {products.map((p) => (
                    <tr key={p.slug} data-testid={`comparison-row-${p.slug}`} className="border-b border-brand-deep/5 last:border-0 hover:bg-brand-beige/40 transition-colors">
                      <td className="px-7 py-4 font-display font-bold text-brand-deep">{p.name}</td>
                      <td className="px-4 py-4 text-brand-charcoal/70">{p.crop}</td>
                      <td className="px-4 py-4">
                        <span className="inline-block bg-brand-gold/15 text-brand-deep text-xs font-bold px-2.5 py-1 rounded-full">{p.pack_size || "25 kg"}</span>
                      </td>
                      <td className="px-4 py-4 text-brand-charcoal/70">{p.region || "Bihar"}</td>
                      <td className="px-7 py-4 text-right">
                        <Link to={`/products/${p.slug}`} data-testid={`comparison-details-${p.slug}`} className="inline-flex items-center gap-1 font-bold text-brand-deep hover:text-brand-gold transition-colors">
                          View Details <ArrowRight className="w-3.5 h-3.5" />
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
